import { Badge, Group, Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { DeploymentGroupWarning } from '@/types/deploymentGroup'
import {
  getGroupWarningBadgeMessageId,
  getGroupWarningMessageId
} from './groupErrorMessages'

type GroupWarningBadgeProps = {
  warning: DeploymentGroupWarning
}

export const GroupWarningBadge = ({ warning }: GroupWarningBadgeProps) => {
  const badgeId = getGroupWarningBadgeMessageId(warning.code)
  const hintId = getGroupWarningMessageId(warning.code)

  return (
    <Group gap="xs" align="flex-start" wrap="nowrap">
      <Badge variant="light" color="orange" size="sm" flex="none">
        {badgeId ? <FormattedMessage id={badgeId} /> : warning.code}
      </Badge>

      <Stack gap={0}>
        {hintId && (
          <Text size="sm">
            <FormattedMessage id={hintId} />
          </Text>
        )}
        {warning.detail && (
          <Text size="xs" c="dimmed">
            {warning.detail}
          </Text>
        )}
      </Stack>
    </Group>
  )
}
